<!-- eslint-disable vue/multi-word-component-names -->
<script setup props="props">
import { ref, computed } from "vue";
import { designs } from "../../dataFiles/Projects/designs";
import { photos } from "../../dataFiles/Projects/photos";
import ProjectsBoxVue from "./ProjectsBox.vue";
import photoshop from "../../assets/images/photoshop-logo.png";
import illustrator from "../../assets/images/adobe-Illustrator.png";
import lightroom from "../../assets/images/adobe-lightroom-logo.png";
import inDesign from "../../assets/images/adobe-animate-logo.png";

const infoA = ref(photos);
const infoB = ref(designs);

let selected = ref("A");

const animationAClass = computed(() => {
  return selected.value === "A" ? "animate-pulse" : "animate-bounce";
});

const animationBClass = computed(() => {
  return selected.value === "B" ? "animate-pulse" : "animate-bounce";
});

let Bfunc = () => {
  selected.value = "B";
  console.log("im am B func");
};

let Afunc = () => {
  selected.value = "A";
};

const skills = [
  {
    name: "Photoshop",
    image: photoshop,
  },
  {
    name: "Illustrator",
    image: illustrator,
  },
  {
    name: "Lightroom",
    image: lightroom,
  },
  {
    name: "InDesign",
    image: inDesign,
  },
];
const services = [
  "Logo",
  "Stationery/Branding",
  "Packaging",
  "Marketing Collateral",
  "Infographics",
  "Social Media Graphics",
  "Illustration",
  "Motion Graphics",
  "Product Design",
];
const designSkills = [
  "Typography",
  "Color Theory",
  "Composition",
  "Layout",
  "Visual Hierarchy",
  "Illustration",
  "User Experience ",
];
</script>

<template>
  <div class="flex justify-center items-center my-20">
    <h1 class="text-2xl font-bold text-white nav-links">
      My <span class="text-yellow-800">Portfolio</span>
    </h1>
  </div>
  <div class="flex flex-col md:flex-row justify-center items-center w-full relative">
    <!-- skills ctn -->
    <div class="flex flex-col justify-around items-center w-full md:w-1/2">
      <!-- skills -->
      <div class="border-2 border-gray-50 my-4 w-[90%] md:w-3/4">
        <div class="flex justify-center items-center">
          <h1 class="text-white font-bold text-xl capitalize my-4">
            software skills
          </h1>
        </div>
        <div
          v-for="skill in skills"
          :key="skill"
          class="flex justify-around items-center my-10"
        >
          <img
            :src="skill.image"
            alt="imege"
            class="cursor-pointer w-[40px] saturate-0 hover:saturate-100 mx-2"
          />
          <p class="text-white mx-2">{{ skill.name }}</p>
          <input type="range" class="mx-6" />
        </div>
      </div>
      <!-- services offered  -->
      <div
        class="flex flex-col md:flex-row justify-around items-center w-full my-4"
      >
        <div
          class="border-2 border-gray-50 w-[300px] h-[400px] flex flex-col justify-around items-center md:mx-10 lg:mx-4 my-5"
        >
          <h1 class="text-white font-bold text-xl my-4">What can I do?</h1>
          <ul class="">
            <li
              v-for="service in services"
              :key="service"
              class="font-semibold text-white cursor-pointer my-3 list-disc"
            >
              {{ service }}
            </li>
          </ul>
        </div>

        <div
          class="border-2 border-gray-50 w-[300px] h-[400px] flex flex-col justify-around items-center md:mx-10 lg:mx-4 my-5"
        >
          <h1 class="text-white font-bold text-xl">Design Skills</h1>
          <ul>
            <li
              v-for="skill in designSkills"
              :key="skill"
              class="font-semibold text-white cursor-pointer my-3 list-disc"
            >
              {{ skill }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Projects ctn -->
    <div class="w-full md:w-[50%]">
      <!-- header -->
      <div class="w-5/6 flex justify-around items-center mx-4 mt-20 rounded-xl">
        <h1
          class="text-white text-2xl cursor-pointer font-bold px-4 py-4 nav-links"
          @click="Afunc"
          :class="animationAClass"
        >
          Photography
        </h1>
        <h1
          class="text-white text-2xl cursor-pointer font-bold px-4 py-4 nav-links"
          @click="Bfunc"
          :class="animationBClass"
        >
          Designs
        </h1>
      </div>
      <div class="my-10">
        <ProjectsBoxVue :info="selected === 'A' ? infoA : infoB" />
      </div>
      <!-- <div class="bg-purple-800 my-20">
        <div v-for="image in projectImages" :key="image">
          <img :src="image.photo" :alt="image" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<style scoped>
/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  width: 15rem;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
  background-color: #fff;
  border-radius: 0.5rem;
  height: 0.3rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  margin-top: -8px; /* Centers thumb on the track */
  background-color: rgb(121, 89, 9);
  border-radius: 50%;
  /*custom styles*/
  height: 1.2rem;
  width: 1.2rem;
}

input[type="range"]::after::-webkit-slider-thumb {
  background-color: ghostwhite;
  height: 0.5rem;
  width: 0.5rem;
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
  background-color: #fff;
  border-radius: 0.5rem;
  height: 0.3rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
  border: none; /*Removes extra border that FF applies*/
  border-radius: 0; /*Removes default border-radius that FF applies*/
  margin-top: -8px; /* Centers thumb on the track */
  background-color: rgb(121, 89, 9);
  border-radius: 50%;
  /*custom styles*/
  height: 1.2rem;
  width: 1.2rem;
}
.gradient {
  background: linear-gradient(to bottom, #b8b3b3, rgb(121, 89, 9));
}
</style>
